import 'flickity/css/flickity.css';
import Flickity from 'flickity';

export default class IssueCarousel {
  constructor(element, issuePath, images = [], onImageClick = () => {}) {
    this.element = element;
    this.issuePath = issuePath;
    this.images = images;
    this.lastIndex = 0;
    this.onImageClick = onImageClick;

    this.init();
  }

  update(images, initialIndex = null) {
    this.destroy();
    this.images = images;
    if (initialIndex !== null) {
      this.lastIndex = initialIndex;
    }
    this.init();
  }

  destroy() {
    if (this.carousel) {
      this.lastIndex = this.carousel.selectedIndex;
      this.carousel.destroy();
      this.carousel = null;
    }
    this.element.innerHTML = '';
  }

  init() {
    if (this.images.length > 0) {
      this.carousel = new Flickity(this.element, {
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        contain: true,
        initialIndex: this.lastIndex,
        draggable: false,
      }).on( 'select', function() {
        /**
         * Adds and removes the scroll class.
         * If the thumbnail container is overflowing
         */
        let element = document.querySelector('.issue__images');
        let isOverflow = element?.scrollWidth > element?.clientWidth;
        isOverflow && element.parentElement.classList.add('issue-field__body--scroll');
        !isOverflow && element.parentElement.classList.remove('issue-field__body--scroll');
      });

      this.images.forEach(image => {
        let wrapper = document.createElement('div');
        wrapper.classList.add('issue__image');
        let a = document.createElement('a');
        a.addEventListener('click', () => {
          this.onImageClick(image);
        });

        let img = document.createElement('img');
        img.src = this.imageSrc(image);
        img.alt = image.image_blob.filename;
        a.appendChild(img);
        wrapper.appendChild(a);

        image.htmlElement = wrapper;
        this.carousel.append(wrapper);
      });
      window.dispatchEvent(new Event('resize'));
    }
  }

  imageSrc(image) {
    if (image.isNew) return image.url;
    return `/internal${this.issuePath}/issue_images/${image.id}.jpeg?variant=medium`;
  }
}
